export const GEOLOCATION_EXPIRY_TIME = 3600000;
export const GEOLOCATION_FAILURE_EXPIRY_TIME = 600000;

export const MAX_FAVORITES = 5;
export const MAX_RECENTLY_SEARCHED = 5;
export const MAX_SEARCH_ROWS = 30;

export const SUPPORT_INTL_LOCATIONS = true;



// WEBPACK FOOTER //
// ../node_modules/@cube/location-model/src/constants/index.js